import { NgModule } from "@angular/core"
import { Routes, RouterModule } from "@angular/router"
import { LayoutComponent } from "./layouts/layout.component"
import { LoginComponent } from "./layouts/login/login.component"
import { AuthGuardService } from "./cadastro/admin/services/auth-guard.service"
import { DashboardComponent } from "./cadastro/admin/components/dashboard/dashboard.component"

const routes: Routes = [
  { path: "", pathMatch: "full", redirectTo: "escolas" },
  {
    path: "cursos",
    loadChildren: () =>
      import("./modules/course/course.module").then(
        ({ CourseModule }) => CourseModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "disciplinas",
    loadChildren: () =>
      import("src/app/modules/subject/subject.module").then(
        ({ SubjectModule }) => SubjectModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "turmas",
    loadChildren: () =>
      import("./modules/class/class.module").then(
        ({ ClassModule }) => ClassModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "permissoes",
    loadChildren: () =>
      import("./modules/permission/permission.module").then(
        ({ PermissionModule }) => PermissionModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "usuarios",
    loadChildren: () =>
      import("./modules/usuario/usuario.module").then(
        ({ UsuarioModule }) => UsuarioModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "integracoes",
    loadChildren: () =>
      import("./modules/integration/integration.module").then(
        ({ IntegrationModule }) => IntegrationModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "ocorrencias",
    loadChildren: () =>
      import("./modules/occurrence/occurrence.module").then(
        ({ OccurrenceModule }) => OccurrenceModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "conteudos",
    loadChildren: () =>
      import("./modules/content/content.module").then(
        ({ ContentModule }) => ContentModule
      ),
  },
  {
    path: "onboarding-documents",
    loadChildren: () =>
      import("./modules/onboarding-documents/onboarding-documents.module").then(
        ({ OnboardingDocumentsModule }) => OnboardingDocumentsModule
      ),
  },
  {
    path: "school/products",
    loadChildren: () =>
      import("src/app/modules/product/product.module").then(
        ({ ProductModule }) => ProductModule
      ),
    canActivate: [AuthGuardService],
  },

  {
    path: "marcas",
    loadChildren: () =>
      import("./modules/brand/brand.module").then(
        ({ BrandModule }) => BrandModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "combos",
    loadChildren: () =>
      import("src/app/modules/combo/combo.module").then(
        ({ ComboModule }) => ComboModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "grupos-economicos",
    loadChildren: () =>
      import("src/app/modules/economic-group/economic-group.module").then(
        ({ EconomicGroupModule }) => EconomicGroupModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "grupos",
    loadChildren: () =>
      import("src/app/modules/group/group.module").then(
        ({ GroupModule }) => GroupModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "perfis",
    loadChildren: () =>
      import("src/app/modules/profile/profile.module").then(
        ({ ProfileModule }) => ProfileModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "tags",
    loadChildren: () =>
      import("src/app/modules/tags/tags.module").then(
        ({ TagsModule }) => TagsModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "segmentos",
    loadChildren: () =>
      import("src/app/modules/segments/segments.module").then(
        ({ SegmentsModule }) => SegmentsModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "series",
    loadChildren: () =>
      import("src/app/modules/grade/grade.module").then(
        ({ GradeModule }) => GradeModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "produtos",
    loadChildren: () =>
      import("src/app/modules/products/products.module").then(
        ({ ProductsModule }) => ProductsModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "licencas",
    loadChildren: () =>
      import("src/app/modules/licenses/licenses.module").then(
        ({ LicensesModule }) => LicensesModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "escolas",
    loadChildren: () =>
      import("src/app/modules/school/school.module").then(
        ({ SchoolModule }) => SchoolModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: "initial-setup",
    loadChildren: () =>
      import("src/app/modules/initial-setup/initial-setup.module").then(
        ({ InitialSetupModule }) => InitialSetupModule
      ),
      canActivate: [AuthGuardService],
  },
  {
    path: "relatorios",
    loadChildren: () =>
      import("./modules/reports/reports.module").then(
        ({ ReportsModule }) => ReportsModule
      ),
  },
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "login",
        component: LoginComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuardService],
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
